
function loadConfiguration(customerID) {
  console.log("try to load customer configuration for %s", customerID)
  var addr = `/configurations/${customerID}.json`
  return fetch(addr)
    .then(function (response) {
      if (response.status !== 200) {
        console.log(
          "Looks like there was a problem. Status Code: " + response.status
        );
        return
      }
      // Return repsonse as json promise
      return response.json()
    })
}

export default {
  loadConfiguration
}
